export const GET_PRE_REGISTRATIONS = "GET_PRE_REGISTRATIONS"
export const GET_PRE_REGISTRATIONS_FAIL = "GET_PRE_REGISTRATIONS_FAIL"
export const GET_PRE_REGISTRATIONS_SUCCESS = "GET_PRE_REGISTRATIONS_SUCCESS"

export const ADD_NEW_PRE_REGISTRATION = "ADD_NEW_PRE_REGISTRATION"
export const ADD_PRE_REGISTRATION_SUCCESS = "ADD_PRE_REGISTRATION_SUCCESS"
export const ADD_PRE_REGISTRATION_FAIL = "ADD_PRE_REGISTRATION_FAIL"

export const UPDATE_PRE_REGISTRATION = "UPDATE_PRE_REGISTRATION"
export const UPDATE_PRE_REGISTRATION_SUCCESS = "UPDATE_PRE_REGISTRATION_SUCCESS"
export const UPDATE_PRE_REGISTRATION_FAIL = "UPDATE_PRE_REGISTRATION_FAIL"

export const DELETE_PRE_REGISTRATION = "DELETE_PRE_REGISTRATION"
export const DELETE_PRE_REGISTRATION_SUCCESS = "DELETE_PRE_REGISTRATION_SUCCESS"
export const DELETE_PRE_REGISTRATION_FAIL = "DELETE_PRE_REGISTRATION_FAIL"


export const SET_SELECTED_PRE_REGISTRATION = "SET_SELECTED_PRE_REGISTRATION";


export const GET_PRE_REGISTRATION_BY_UUID = "GET_PRE_REGISTRATION_BY_UUID"
export const GET_PRE_REGISTRATION_BY_UUID_SUCCESS = "GET_PRE_REGISTRATION_BY_UUID_SUCCESS"
export const GET_PRE_REGISTRATION_BY_UUID_FAIL = "GET_PRE_REGISTRATION_BY_UUID_FAIL"


export const APPROVE_PRE_REGISTRATION = "APPROVE_PRE_REGISTRATION";
export const APPROVE_PRE_REGISTRATION_SUCCESS = "APPROVE_PRE_REGISTRATION_SUCCESS";
export const APPROVE_PRE_REGISTRATION_FAIL = "APPROVE_PRE_REGISTRATION_FAIL";

export const REJECT_PRE_REGISTRATION = "REJECT_PRE_REGISTRATION";
export const REJECT_PRE_REGISTRATION_SUCCESS = "REJECT_PRE_REGISTRATION_SUCCESS";
export const REJECT_PRE_REGISTRATION_FAIL = "REJECT_PRE_REGISTRATION_FAIL";


// POUR REMETTRE LA VALEUR DE ACTION_SUCCESS = FALSE
export const RESET_PRE_REGISTRATION_ACTION = "RESET_PRE_REGISTRATION_ACTION";









